import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { Modal } from 'containers/misc'
import { OrganizationStateChange } from 'containers/forms/organizations'
import { OrganizationSummary } from 'components/sections/organizations'
import { Module } from 'components/misc'
import { modal } from 'redux/modules/app'
import OrganizationManageGOP
  from '../../../../containers/forms/organizations/OrganizationManageGOP/OrganizationManageGOP'
import { get } from 'lodash'
import { CONFIGURATION_KEYS, ORGANIZATION_HIERARCHY, ROLES } from '../../../../constants/enums'
import { apiConfiguration } from '../../../../helpers/decorators/api'


@connect(({ auth }) => ({
  activeOrganization: auth.organization
}), { modal })
@apiConfiguration()
class OrganizationOverview extends Component {
  static propTypes = {
    organizationStates: PropTypes.array,
    updateOrganizationState: PropTypes.func,
    modal: PropTypes.func,
    data: PropTypes.object,
    displaySettings: PropTypes.bool,
    activeOrganization: PropTypes.object.isRequired,
    configuration: PropTypes.object
  }

  static defaultProps = {
    displaySettings: true
  }

    render() {
    const { displaySettings, data, configuration, activeOrganization } = this.props

    const orgId = get(activeOrganization, 'id')

    const isGOPEnabled = get(configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isGOPEnabled.id}].booleanValue`)

    const actions = [
      {
        id: 1,
        label: "Change Organisation's state",
        intlKey: 'organisation.change_organisation_state',
        onClick: () => this.props.modal('organization-state-change')
      },
      {
        id: 2,
        label: 'Manage Global Operating Partner',
        intlKey: 'organisation.manage_gop',
        onClick: () => this.props.modal('organization-manage-gop'),
        hideForRoles: [
            ORGANIZATION_HIERARCHY.AU.value,
            ORGANIZATION_HIERARCHY.NAO.value,
            ORGANIZATION_HIERARCHY.GOP.value,
            ORGANIZATION_HIERARCHY.SGOP.value
        ],
        roles: [ROLES.IF_STAFF_SUPER.u, ROLES.GBT.u],
        hide: !isGOPEnabled
      }
    ]

    let filteredActions = []

    filteredActions = actions.filter(item => {
      if (item.hideForRoles && item.hideForRoles.includes(get(data, 'hierarchyLevel.value'))) {
        return false
      } else if(item.hide){
        return false
      }
      return item
    })

    return (
      <div>
        <Module
          title={displaySettings ? 'Overview' : ''}
          intlKey="moduleTitle.overview"
          primary
          grid
          actionDropdown={displaySettings ? 'Organisation Settings' : ''}
          actionDropdownActions={filteredActions}
          intlKeyAction="button.organisation_settings"
          iconAction="settings"
        >
          <OrganizationSummary data={data} />
        </Module>

        <Modal
          id="organization-state-change"
          compact
          action="Select"
          intlKeyAction="modal.select"
          customActions
        >
          <OrganizationStateChange
            organizationStates={this.props.organizationStates}
            data={data}
            updateOrganizationState={this.props.updateOrganizationState}
          />
        </Modal>
        <Modal id="organization-manage-gop" compact customActions>
          <OrganizationManageGOP
              organisationId={get(data, 'id')}
              gopId={get(data, 'parentGOP.id')}
              sgopId={get(data, 'parentSubGOP.id')}
              onClose={() => this.props.modal(null)}
          />
        </Modal>
      </div>
    )
  }
}

export default OrganizationOverview
